import { motion } from "framer-motion";
import Model from "../Model";
import video from "../../images/dumpster.mp4";
import Button from "../Button";

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  onConfirmTitle = "Yes, Delete It!",
  title = "Are you Sure?",
  subtitle = "Are you sure you want to delete this account?",
  loading = false,
}) => {
  return (
    <Model isOpen={isOpen} onClose={onClose} name={title || "Verification Required"}>
      <div className="p-2 text-center max-w-md mx-auto">
        <div className="flex justify-center mb-5 text-red-500">
           <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
        </div>

        {/* Title & Subtitle */}
        <h2 className="text-[18px] font-bold text-gray-800 uppercase tracking-tight">{title}</h2>
        <p className="text-[13px] text-gray-500 mt-2 font-medium leading-relaxed">{subtitle}</p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 mt-8">
          <button
            onClick={onConfirm}
            disabled={loading}
            className="bg-red-600 text-white px-8 py-2.5 font-bold text-[12px] uppercase tracking-widest transition hover:bg-red-700 border border-red-600"
          >
            {loading ? "Processing..." : onConfirmTitle}
          </button>
          <button
            onClick={onClose}
            className="bg-white text-gray-600 px-8 py-2.5 font-bold text-[12px] uppercase tracking-widest transition hover:bg-gray-50 border border-gray-300"
          >
             Cancel
          </button>
        </div>
      </div>
    </Model>

  );
};

export default ConfirmDeleteModal;
